import { useParams } from "react-router-dom";
import { useResolvedAuth } from "../hooks/useResolvedAuth";
import { PageLoader } from "../components/PageLoader/PageLoader";
import { VolunteerDetail } from "./VolunteerDetail";
import { PublicVolunteerDetail } from "./PublicVolunteerDetail";
import { VolunteerProfile } from "./VolunteerProfile";

export const UniversalVolunteerDetail = () => {
  const { volunteerId } = useParams<{ volunteerId: string }>();
  const { isAuthenticated, currentUser, isAuthResolving } = useResolvedAuth();

  if (isAuthResolving) {
    return <PageLoader />;
  }

  if (!isAuthenticated) {
    return <PublicVolunteerDetail />;
  }

  const isOwnProfile = currentUser?.userId === volunteerId;

  if (isOwnProfile) {
    return <VolunteerProfile />;
  }

  return <VolunteerDetail />;
};
